import styled from 'styled-components';

const TabLine = styled.div<{ $color?: string }>`
	position: absolute;
	bottom: 1px;
	left: var(--left);
	width: var(--width);
	height: 2px;
	background-color: ${(props) => props.$color || '#FFFFFF'};
	border-radius: 4px;
	transition:
		left 0.25s ease,
		width 0.25s ease,
		background-color 0.3s ease,
		opacity 0.3s ease;
`;

export { TabLine };
